import React from "react";

function Story() {
  return (
    <div id="story" className="story section">
      <div className="container mx-auto">
        <div className="title">
          <h1>Koon Story</h1>
          <img src="/images/claw_title.png" alt="Claw" className="claw-title" />
        </div>
        <div className="img_txt">
          <div>
            <img
              src="./images/story_bg.jpg"
              alt="Koon"
              className="koon_story"
            />
          </div>
          <div>
            <p className="txt">
              Koon is a unique memecoin inspired by the majestic Maine Coon cat
              breed, known for its impressive size and affectionate nature.
              Unlike the many memecoins dominated by dogs, Koon embodies feline
              power and nobility to unite a bold community movement. The goal is
              clear: to bring together an engaged and united community to
              overthrow the dominance of dog-themed memecoins and put cats back
              at the center of the stage. Koon is more than just a token; it’s a
              symbol of rebellion and humor, ready to conquer the crypto world
              while supporting noble causes in animal protection.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-12">
        <a
          href="https://t.me/+up4v1c1H0fdiMjE0"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold button"
        >
          Join Telegram
        </a>
      </div>
    </div>
  );
}

export default Story;
